var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StateProvider } from '../services/state-provider';
import { RouteUrlTypes, CatalogDataType } from '../components/MainView/MainView.container.props';
import { CMSFeedMap } from '../components/MainView/MainViewMaps';
import { Networker } from '@idp/networker';
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { ScreenLoader } from '@idp/ui-components';
import { getCartResp } from '@idse/cart-ui/utils/UtilityFunctions';
import { acpVerification, getAcpEligibilityPromo, getAcpAccessPromo, isAcpSystemError } from '@idse/cart-ui/utils/CartUtilFunctions';
import { ErrorTypeOption, SuccessFlags } from '../services/AnalyticsEvents';
import ReportingGateway from '../services/ReportingGateway';
var MOBILE_BREAKPOINT = 1024;
var CSRF_TOKEN = 'csrf-token';
var Loader = /** @class */ (function () {
    function Loader() {
        this.loaderComponent = null;
    }
    Loader.prototype.showLoader = function (element) {
        var loaderElement = document.querySelector('.ScreenLoader__screen-loader');
        if (loaderElement) {
            return;
        }
        this.loaderElement = document.createElement('div');
        if (element) {
            element.appendChild(this.loaderElement);
        }
        else {
            document.body.appendChild(this.loaderElement);
        }
        ReactDOM.render(this.getLoaderComponentInstance(true), this.loaderElement);
    };
    Loader.prototype.getLoaderComponentInstance = function (flag) {
        if (this.loaderComponent == null) {
            this.loaderComponent = React.createElement(ScreenLoader, { data: {}, options: { isEnabled: flag } });
        }
        return this.loaderComponent;
    };
    Loader.prototype.hideLoader = function (element) {
        var loaderElement = document.querySelector('.ScreenLoader__screen-loader');
        if (this.loaderElement && loaderElement) {
            ReactDOM.unmountComponentAtNode(this.loaderElement);
            if (element) {
                element.removeChild(this.loaderElement);
            }
            else {
                document.body.removeChild(this.loaderElement);
            }
        }
    };
    return Loader;
}());
export default Loader;
export function isMobile() {
    return (window.innerWidth < MOBILE_BREAKPOINT);
}
export function setTabTitle(title) {
    document.title = title;
}
export function getUrlParamValue(field, url) {
    var filter = new RegExp('[?&]' + field + '=([^&#]*)');
    var paramValue = filter.exec(url);
    return paramValue ? paramValue[1] : null;
}
export var isIncompleteCart = function (payload) {
    var isCartIncomplete = false;
    if (payload) {
        var info = payload;
        if (info.wirelessCart && info.wirelessCart.requiredToCheckout) {
            var requiredToCheckout = info.wirelessCart.requiredToCheckout;
            for (var _i = 0, requiredToCheckout_1 = requiredToCheckout; _i < requiredToCheckout_1.length; _i++) {
                var itemRC = requiredToCheckout_1[_i];
                if (itemRC) {
                    isCartIncomplete = true;
                }
            }
        }
        else if (info.commonCart && info.commonCart.requiredToCheckout) {
            var requiredToCheckout = info.commonCart.requiredToCheckout;
            for (var _a = 0, requiredToCheckout_2 = requiredToCheckout; _a < requiredToCheckout_2.length; _a++) {
                var itemRC = requiredToCheckout_2[_a];
                if (itemRC) {
                    isCartIncomplete = true;
                }
            }
        }
        else if (info && info.cartStatus &&
            !info.cartStatus.readyToCheckout && info.cartStatus.cartState &&
            info.cartStatus.cartState.toUpperCase() === 'INCOMPLETE') {
            isCartIncomplete = true;
        }
    }
    return isCartIncomplete;
};
export function getIDSEIntent() {
    var wlsIntentFromSession = StateProvider.getStateManagerInstance().get('appShell', 'IDSEIntent');
    var intent = null;
    if (getQueryParamValue('wlsfi')) {
        intent = getQueryParamValue('wlsfi');
    }
    else if (wlsIntentFromSession) {
        intent = wlsIntentFromSession.wirelessIntent;
    }
    else if (getIDSEIntentFromCookie()) {
        intent = getIDSEIntentFromCookie();
    }
    return (intent ? intent.toLowerCase() : '');
}
export function getIDSEIntentFromCookie() {
    var wirelessAuth = getCookie('v_wirelessAuth');
    if (wirelessAuth) {
        var wirelessAuthObj = JSON.parse(wirelessAuth);
        if (wirelessAuthObj.hasOwnProperty('authenticated') &&
            JSON.stringify(wirelessAuthObj.authenticated).search('true') > -1) {
            if (wirelessAuthObj.hasOwnProperty('flowType') &&
                JSON.stringify(wirelessAuthObj.flowType).search('UP') > -1) {
                return 'up';
            }
            if (wirelessAuthObj.hasOwnProperty('flowType') &&
                JSON.stringify(wirelessAuthObj.flowType).search('AL') > -1) {
                return 'al';
            }
        }
    }
    return null;
}
export function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
        var value = ca_1[_i];
        while (value.charAt(0) === ' ') {
            value = value.substring(1);
        }
        if (value.indexOf(name) === 0) {
            return value.substring(name.length, value.length);
        }
    }
    return null;
}
export function getQueryParamValue(param) {
    var baseURL = StateProvider.getStateManagerInstance().get('appShell', 'baseURL');
    var appShellBaseURL = baseURL ? baseURL.url.toLowerCase() : window.location.href;
    return getUrlParamValue(param, appShellBaseURL);
}
export function getCatalogDataType() {
    var baseURL = StateProvider.getStateManagerInstance().get('appShell', 'baseURL');
    var url = baseURL && baseURL.url ? baseURL.url.toLowerCase() : window.location.href;
    if (url.indexOf(RouteUrlTypes.BROADBAND) > -1) {
        return CatalogDataType.Broadband;
    }
    else if (url.indexOf(RouteUrlTypes.DIRECTV) > -1) {
        return CatalogDataType.DTV;
    }
    else if (url.indexOf(RouteUrlTypes.WIRELESS) > -1) {
        return CatalogDataType.Wireless;
    }
    else if (url.indexOf(RouteUrlTypes.IPTV) > -1) {
        return CatalogDataType.IPTV;
    }
    else if (url.indexOf(RouteUrlTypes.OFFERS) > -1) {
        return CatalogDataType.Offers;
    }
    else if (url.indexOf(RouteUrlTypes.BUNDLE) > -1) {
        return CatalogDataType.Bundle;
    }
    else if (url.indexOf(RouteUrlTypes.CART) > -1 || url.indexOf(RouteUrlTypes.CHECKOUT) > -1) {
        return CatalogDataType.CARTCHECKOUT;
    }
    else {
        return CatalogDataType.CARTCHECKOUT;
    }
}
export function getCMSFeedName() {
    var isThankyouPage = window.location.href.toLowerCase().indexOf('thankyou') > -1;
    var feedUrl = CMSFeedMap.get(getCatalogDataType());
    return isThankyouPage ? 'thankyou' : feedUrl ? feedUrl.split('/idpcms/sales/buy/')[1] : null;
}
// Check if passed key chain is exist in passed object.
// tslint:disable-next-line:no-any
export function isKeyExist(obj, key) {
    if (key === null || typeof key === 'undefined' || (key === '')) {
        return false;
    }
    return key.split('.').every(function (s) {
        if (isEmptyObject(obj) || !obj.hasOwnProperty(s)) {
            return false;
        }
        obj = obj[s];
        return true;
    });
}
// Check if passed object is undefined or empty or null.
export function isEmptyObject(obj) {
    return (obj === null || typeof obj === 'undefined' || typeof obj !== 'object' || (Object.keys(obj).length === 0));
}
export function isEmpty(value) {
    return (value === null || typeof value === 'undefined' || (value === ''));
}
export function utilFetchCRT() {
    var options = {};
    var stateCsrfToken = StateProvider.getStateManagerInstance().get('appShell', CSRF_TOKEN);
    var customHeaders = new Headers();
    if (stateCsrfToken && stateCsrfToken.value) {
        customHeaders.set('X-CSRF-TOKEN', stateCsrfToken.value);
        options = {
            headers: customHeaders,
        };
    }
    return options;
}
export function setCookie(name, value, expDays) {
    if (expDays) {
        expDays = 365;
    }
    var d = new Date();
    d.setTime(d.getTime() + (expDays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
export function cookieToObj(cookie) {
    var cookieArr = cookie.split('; ');
    var result = {};
    for (var i = 0; i < cookieArr.length; i++) {
        var cur = cookieArr[i].split('=');
        result[cur[0]] = cur[1];
    }
    return result;
}
export function getCartResponse() {
    var cartResponse = StateProvider.getStateManagerInstance().
        get('appShell', 'cartResponse');
    if (cartResponse && cartResponse.content && cartResponse.content.payload) {
        return cartResponse;
    }
    else {
        return null;
    }
}
export function updateReadyToCheckoutValueOnChartSummaryResponse() {
    var _a, _b, _c, _d, _e, _f, _g;
    var cartResponse = getCartResponse();
    if ((_d = (_c = (_b = (_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.commonCart) === null || _c === void 0 ? void 0 : _c.cartStatus) === null || _d === void 0 ? void 0 : _d.readyToCheckout) {
        cartResponse.content.payload.commonCart.cartStatus.readyToCheckout = false;
        StateProvider.getStateManagerInstance().set('cartResponse', cartResponse);
    }
    else if ((_g = (_f = (_e = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.cartStatus) === null || _g === void 0 ? void 0 : _g.readyToCheckout) {
        cartResponse.content.payload.cartStatus.readyToCheckout = false;
        StateProvider.getStateManagerInstance().set('cartResponse', cartResponse);
    }
}
export function isNativeAppRedirectionNeeded() {
    var _a, _b;
    var cartResponse = getCartResponse();
    var isNativeApp = StateProvider.getStateManagerInstance().get('appShell', 'channeltype');
    return ((_b = (_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.enableNativeAppRedesign) && isNativeApp;
}
export function getPostpaidflowtype() {
    var cartResponse = getCartResponse();
    var flowtype = '';
    if (cartResponse && cartResponse.content && cartResponse.content.payload && cartResponse.content.payload.metadata &&
        cartResponse.content.payload.metadata.metadata && cartResponse.content.payload.metadata.metadata.orderSubType) {
        if (cartResponse.content.payload.metadata.metadata.orderSubType === 'AAL_WIRELESS') {
            flowtype = 'AL';
        }
        if (cartResponse.content.payload.metadata.metadata.orderSubType === 'UPGRADE_WIRELESS' ||
            cartResponse.content.payload.metadata.metadata.orderSubType === 'UP_AL_WIRELESS') {
            flowtype = 'UP';
        }
    }
    return flowtype;
}
export function isIxpFeatureEnabled(feature) {
    var stateManager = StateProvider.getStateManagerInstance();
    // tslint:disable-next-line:no-any
    var featureToggleData = stateManager.get('appShell', 'featureToggleStatus');
    console.log('core: featureToggleData', featureToggleData);
    if (featureToggleData && featureToggleData.allocations
        && featureToggleData.allocations[feature]) {
        if (featureToggleData.allocations[feature].value === 'true') {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
export function isIxpCheckoutFeatureEnabled(feature) {
    var stateManager = StateProvider.getStateManagerInstance();
    // tslint:disable-next-line:no-any
    var featureToggleData = stateManager.get('CHECKOUT', 'featureToggles');
    console.log('core >> CHECKOUT: featureToggleData', featureToggleData);
    if (featureToggleData && featureToggleData.allocations
        && featureToggleData.allocations[feature]) {
        if (featureToggleData.allocations[feature].value === 'true') {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
export function getProfileInfo() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Networker().get('/msapi/accountservices/v1/profile/info')
                    .then(function (response) {
                    if (response.ok) {
                        return response.json();
                    }
                    else {
                        return Promise.reject(response);
                    }
                })
                    .then(function (res) {
                    return Promise.resolve(res);
                })
                    .catch(function (err) {
                    return Promise.reject(err);
                })];
        });
    });
}
export function updateDetails() {
    var url = location.href;
    var params = url === null || url === void 0 ? void 0 : url.split(/[&=\/]+/);
    var insuranceNT = params && params[(params === null || params === void 0 ? void 0 : params.indexOf('insuranceNT')) + 1];
    var tradeNT = params && params[(params === null || params === void 0 ? void 0 : params.indexOf('tradeinNT')) + 1];
    var channel = params && params[(params === null || params === void 0 ? void 0 : params.indexOf('channeltype')) + 1];
    var channelType = { type: channel };
    var isBypasstradeInPresent = params && params[(params === null || params === void 0 ? void 0 : params.indexOf('bypasstradein')) + 1];
    var tradeIn = { type: '' + !!isBypasstradeInPresent };
    if (insuranceNT && insuranceNT === 'true' || tradeNT && tradeNT === 'true') {
        var data = {};
        data = {
            insuranceNT: insuranceNT === 'true' ? true : false,
            tradeinNT: tradeNT === 'true' ? true : false,
        };
        StateProvider.getStateManagerInstance().set('nativeInfo', data);
    }
    if (channelType === null || channelType === void 0 ? void 0 : channelType.type) {
        StateProvider.getStateManagerInstance().set('channeltype', channelType);
    }
    StateProvider.getStateManagerInstance().set('bypasstradein', tradeIn);
}
export var isPrepaidTaxCalculated = function () {
    var _a, _b, _c, _d;
    var WirelessCartResponse = StateProvider.getStateManagerInstance().
        get('WIRELESS', 'cartResponse');
    var cartResponse = WirelessCartResponse || getCartResponse();
    if (cartResponse && cartResponse.content && cartResponse.content.payload) {
        var payload = cartResponse.content.payload;
        var isPrepaid = ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a._paymentType) === 'PREPAID' ||
            ((_d = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.wirelessMetadata) === null || _d === void 0 ? void 0 : _d.paymentType) === 'PREPAID';
        var isTaxCalculated = payload.orderPriceInfo &&
            payload.orderPriceInfo.taxCalculated;
        return (isPrepaid && isTaxCalculated) ? true : false;
    }
    else {
        return null;
    }
};
export function getConnectedCarOrderSrc(paramArray) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var hasOrderSrc = paramArray && paramArray.filter(function (param) { return param.includes('ordersrc='); }).length > 0;
    if (!hasOrderSrc) {
        var authRedirectUrlSession = sessionStorage.getItem('Wireless:AuthRedirectUrl');
        hasOrderSrc = !!new URLSearchParams(authRedirectUrlSession).get('ordersrc');
    }
    if (!hasOrderSrc) {
        var cartResponse = JSON.parse(sessionStorage.getItem("appShell:cartResponse"));
        !cartResponse && (cartResponse = JSON.parse(sessionStorage.getItem('CART:cartResponse')));
        hasOrderSrc = (((_d = (_c = (_b = (_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.wirelessCart) === null || _c === void 0 ? void 0 : _c.externalOrderSource) === null || _d === void 0 ? void 0 : _d.includes('SMART')) || ((_j = (_h = (_g = (_f = (_e = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.orderSource) === null || _j === void 0 ? void 0 : _j.includes('SMART'))) || ((_m = (_l = (_k = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.payload) === null || _k === void 0 ? void 0 : _k.lobList[0]) === null || _l === void 0 ? void 0 : _l.externalOrderSource) === null || _m === void 0 ? void 0 : _m.includes('SMART'));
    }
    return hasOrderSrc;
}
export function isWearableOnDevice() {
    var _a;
    var payload = getCartResp();
    var globalNavWearable;
    if (payload && payload.wirelessCart) {
        Object.keys((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs).forEach(function (elem) {
            var _a, _b;
            var lineItems = Object.values((_b = (_a = payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs[elem]) === null || _b === void 0 ? void 0 : _b.lineItems);
            // tslint:disable-next-line: no-any
            lineItems.forEach(function (lineItem) {
                var _a, _b;
                if ((lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === 'HARDGOOD') {
                    ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.orderSubType) ===
                        'AAL_WIRELESS_ON_ACTIVATION'
                        ? (globalNavWearable = true)
                        : (globalNavWearable = false);
                }
            });
        });
    }
    return globalNavWearable;
}
export function getFlowType() {
    var _a, _b, _c, _d;
    var isEAPFlow = false;
    var wlsPostpaid = JSON.parse(sessionStorage.getItem("wlsPostpaid"));
    var displayATTBannerLogo = sessionStorage.getItem('displayATTBannerLogo');
    if (wlsPostpaid) {
        isEAPFlow = (((_b = (_a = wlsPostpaid.wsceData) === null || _a === void 0 ? void 0 : _a.eapFlow) === null || _b === void 0 ? void 0 : _b.flowType) === "EAP" ||
            ((_d = (_c = wlsPostpaid.wsceData) === null || _c === void 0 ? void 0 : _c.eapFlow) === null || _d === void 0 ? void 0 : _d.ondeviceipadactivation) === "true") ? true : false;
    }
    else if (displayATTBannerLogo || displayATTBannerLogo === 'true') {
        isEAPFlow = true;
    }
    return isEAPFlow;
}
export function isAtleastOneLineLevelPrePreOrderIndicator(payload) {
    var _a;
    var atleastOneLineLevelPrePreOrderIndicator = false;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (atleastOneLineLevelPrePreOrderIndicator === true) {
                return;
            }
            var deviceLineItem = getDeviceDetailsFromLOSG(key, payload);
            atleastOneLineLevelPrePreOrderIndicator = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.prePreOrderIndicator;
        });
    }
    return atleastOneLineLevelPrePreOrderIndicator;
}
export function getDeviceDetailsFromLOSG(losgID, payload) {
    var _a;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        var wirelessLosgs = payload.wirelessCart.losgs[losgID];
        var allItemsList = (wirelessLosgs && wirelessLosgs.lineItems && Object.values(wirelessLosgs.lineItems));
        return allItemsList && allItemsList.filter(function (values) { return (values.itemType === 'device'); })[0];
    }
    return null;
}
export function isExternalOrderSource() {
    var payload = getCartResp();
    if (payload && payload.wirelessCart && payload.wirelessCart.externalOrderSource) {
        return true;
    }
    else {
        return false;
    }
}
export function acpVerificationAccessPromo() {
    var payload = getCartResp();
    return (payload && payload.acpVerificationforAccessPromo);
}
export function getRetrievedCartFlag() {
    var cartRetFlag = '-2';
    var pageUrl = (window === null || window === void 0 ? void 0 : window.location) ? window.location.href : '';
    if (pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.includes('sharedCart=true')) {
        cartRetFlag = '1';
    }
    else if (pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.includes('retrieveCart=true')) {
        cartRetFlag = '0';
    }
    if (cartRetFlag !== '-2') {
        return {
            cartRetrievedFlag: cartRetFlag,
        };
    }
    else {
        return {};
    }
}
export function setFlowCodeandProductTypeValues(urlVal) {
    return {
        'page.attributes.productType': '',
        'page.pageInfo.flowCode': 'DSUNK',
        'page.location.url': urlVal,
        'page.pageInfo.friendlyPageName': notifyFriendlyName[urlVal],
    };
}
export function getACPCartFlag() {
    var payload = getCartResp();
    var isACPVerification = acpVerification();
    var acpSystemError = isAcpSystemError();
    var acpPromo = getAcpEligibilityPromo();
    var acpVerificationAcessPromo = (payload === null || payload === void 0 ? void 0 : payload.acpVerificationforAccessPromo) === true;
    var acpAccessPromo = getAcpAccessPromo();
    var acpIneligibleReason;
    var affordableConnectivityProgramFlag;
    var customerSegment;
    var acpAccessPromotionFlag;
    if (isACPVerification) {
        acpIneligibleReason = 'ACP verification error';
    }
    else if (acpSystemError) {
        acpIneligibleReason = ' ACP System error';
    }
    else if (acpVerificationAcessPromo) {
        acpIneligibleReason = ' ACP Access Promo Verification error';
    }
    else {
        return {};
    }
    if (acpPromo) {
        affordableConnectivityProgramFlag = '1';
    }
    else {
        affordableConnectivityProgramFlag = '0';
    }
    if ((acpPromo === null || acpPromo === void 0 ? void 0 : acpPromo.acpEligibility) === 'TRIBAL') {
        customerSegment = 'Tribal';
    }
    else if ((acpPromo === null || acpPromo === void 0 ? void 0 : acpPromo.acpEligibility) === 'NON_TRIBAL') {
        customerSegment = 'Non-Tribal';
    }
    if ((acpAccessPromo === null || acpAccessPromo === void 0 ? void 0 : acpAccessPromo.isAccessPromo) === true) {
        acpAccessPromotionFlag = '1';
    }
    else {
        acpAccessPromotionFlag = '0';
    }
    return {
        acpAccessPromotionFlag: acpAccessPromotionFlag,
        acpIneligibleReason: acpIneligibleReason,
        affordableConnectivityProgramFlag: affordableConnectivityProgramFlag,
        customerSegment: customerSegment,
    };
}
export function reportPageLoad(errorInResponse, erroCode) {
    var _pathname = location.pathname;
    if (location.pathname && !location.search) {
        _pathname = location.pathname.includes("/buy/cart/") ? '/buy/cart' : location.pathname;
    }
    var addData = {
        additionalData: __assign({ url: _pathname + location.search }, setFlowCodeandProductTypeValues(_pathname)),
        eventAction: 'pageLoad',
        eventCode: 'Page_Load',
    };
    ReportingGateway.sendReportingEvent(addData);
    fireSystemEvent(errorInResponse, _pathname, erroCode);
}
export function fireSystemEvent(errorInResponse, urlValue, erroCode) {
    console.log('System Event Fired');
    var addData3 = {
        additionalData: __assign(__assign(__assign(__assign({}, getRetrievedCartFlag()), getACPCartFlag()), { errorType: errorInResponse ? ErrorTypeOption.Failure_Data : ErrorTypeOption.Success_Admit, statusCode: errorInResponse ? (erroCode ? erroCode : '-2') : '0', statusMessage: errorInResponse ? "cartError - " + errorInResponse : 'success', successFlag: errorInResponse ? SuccessFlags.UNSUCCESSFUL : SuccessFlags.SUCCESSFUL }), setFlowCodeandProductTypeValues(urlValue)),
        eventAction: 'systemEvent',
        eventCode: 'DS_System_Cart_Summary_Display',
    };
    ReportingGateway.sendReportingEvent(addData3);
}
export function isReadyToCheckout() {
    var _a, _b, _c;
    var payload = getCartResp();
    var readyTOCheckout = (((_a = payload === null || payload === void 0 ? void 0 : payload.cartStatus) === null || _a === void 0 ? void 0 : _a.readyToCheckout) || ((_c = (_b = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _b === void 0 ? void 0 : _b.cartStatus) === null || _c === void 0 ? void 0 : _c.readyToCheckout)) ?
        true : false;
    return readyTOCheckout;
}
export function isItemOOS(payload) {
    var isCommonMethod = false;
    var insufficientQty = false;
    if (payload && payload.wirelessCart && (payload === null || payload === void 0 ? void 0 : payload.enableValidateInventory)) {
        isCommonMethod = payload.wirelessCart.deliveryMethods &&
            payload.wirelessCart.deliveryMethods.length === 0;
        insufficientQty = payload.wirelessCart.insufficientRequestedQty;
        return !!(isCommonMethod || insufficientQty);
    }
}
export function onCartIsTaxCalculated() {
    var cartResponse = getCartResponse();
    var taxCalculated = false;
    if (cartResponse && cartResponse.content && cartResponse.content.payload &&
        cartResponse.content.payload.orderPriceInfo && cartResponse.content.payload.orderPriceInfo) {
        taxCalculated = !!(cartResponse.content.payload.orderPriceInfo && cartResponse.content.payload.orderPriceInfo.taxCalculated);
    }
    return taxCalculated;
}
export function IsWirelessInCart(payload) {
    var _a, _b;
    var exist = false;
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        exist = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.productCategory === 'WIRELESS';
        }).length > 0;
    }
    else if ((_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs) {
        exist = Object.values(payload.wirelessCart.losgs).filter(function (value) {
            return value.losgType === 'NEW' || value.losgType === 'UP' || value.losgType === 'AAL' ||
                value.losgType === 'AL' || value.losgType === 'EAAL' || value.losgType === 'PARK';
        }).length > 0;
    }
    else {
        exist = !!(isThisLOBInMetaData('WIRELESS', payload)
            && payload.wirelessCart);
    }
    return exist;
}
export function isThisLOBInMetaData(lobName, payload) {
    var lobList = getLobList(payload);
    return !!(lobList && lobList.indexOf(lobName) !== -1);
}
export function getLobList(payload) {
    var _a, _b;
    var lobList = [];
    if (payload && payload.commonCart && payload.commonCart.losgs) {
        Object.values(payload.commonCart.losgs).forEach(function (value) {
            return lobList.push(value.productCategory);
        });
    }
    else {
        lobList = (((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lobList) ? payload.metadata.metadata.lobList : []);
    }
    return lobList;
}
export function getCurrentFlowType(payload) {
    if (payload &&
        payload.metadata && payload.metadata.metadata &&
        payload.metadata.metadata.wirelessMetadata &&
        payload.metadata.metadata.wirelessMetadata.paymentType) {
        return payload.metadata.metadata.wirelessMetadata.paymentType;
    }
    return getOrderSubType(payload);
}
export function getOrderSubType(payload) {
    var flowType;
    if (payload && payload.commonCart) {
        var losgTypeFound = void 0;
        Object.values(payload.commonCart.losgs).forEach(function (value) {
            flowType = (value.losgType === 'PRICE_CHANGE') ? flowType : value.losgType + '_' + value.productCategory;
        });
        flowType = losgTypeFound || flowType;
    }
    else {
        flowType = (payload &&
            payload.metadata && payload.metadata.metadata
            && payload.metadata.metadata.orderSubType);
    }
    return flowType;
}
export var docComplete = function (handleDocumentComplete) {
    if (typeof window && document) {
        document.removeEventListener('readystatechange', handleDocumentComplete);
        if (document.readyState === 'interactive') {
            document.addEventListener('readystatechange', handleDocumentComplete, false);
        }
        else {
            setTimeout(handleDocumentComplete, 2);
        }
    }
};
export function getCartMetaFlowType(data) {
    var _a, _b, _c, _d;
    var currentLOB = data === null || data === void 0 ? void 0 : data.lobList[0];
    var currentLOSG = ((_a = data === null || data === void 0 ? void 0 : data.baseCartMetadata) === null || _a === void 0 ? void 0 : _a.losgType) && Object.keys((_b = data === null || data === void 0 ? void 0 : data.baseCartMetadata) === null || _b === void 0 ? void 0 : _b.losgType);
    var currentLOSGType = (currentLOSG === null || currentLOSG === void 0 ? void 0 : currentLOSG[0]) && ((_d = (_c = data === null || data === void 0 ? void 0 : data.baseCartMetadata) === null || _c === void 0 ? void 0 : _c.losgType) === null || _d === void 0 ? void 0 : _d[currentLOSG === null || currentLOSG === void 0 ? void 0 : currentLOSG[0]]);
    if (currentLOB && currentLOSGType) {
        return currentLOSGType + "_" + currentLOB;
    }
    else if (currentLOB) {
        return currentLOB;
    }
    return '';
}
export var notifyFriendlyName = {
    '/buy/cart': 'DS Cart Summary Pg',
    '/buy/cart/futurebills/modal': 'DS Cart Future Bills Modal Pg',
    '/buy/cart/save/modal': 'DS Cart Save Cart Modal Pg',
    '/buy/cart/promo': 'DS Cart Promotion Pg',
    '/buy/cart/emptycart': 'DS Checkout Empty Cart Pg',
    '/buy/cart/errorcto': 'DS Cart Error CTO Pg',
    '/buy/cart/removeallitems/modal': 'DS Cart Remove All Items Modal Pg',
    '/buy/cart/retrieve/modal': 'DS Cart Retrieve Cart Modal Pg',
    '/buy/cart/seedetailsduetoday/modal': 'Ds Cart Due Today Details Modal Pg',
    '/buy/cart/seedetailsduefirstbill/modal': 'Ds Cart First Bill Due Details Modal Pg',
    '/buy/cart/multiaddressmodal': 'DS Cart Multi Address Modal Pg',
    '/buy/cart/promotions': 'DS Cart Promotion Pg',
    '/buy/cart/deliveryinfo': 'DS Checkout Express Shipping Info Pg',
    '/buy/cart/accessfeehelp/modal': 'DS Cart Access Fee Help Modal Pg',
    '/buy/cart/paymentschedule/modal': 'DS Cart Payment Schedule Modal Pg',
    '/buy/cart/sharecart/modal': 'DS Cart Sharecart Modal Pg',
    '/buy/cart/pricebreakdown/modal': 'DS Cart Pricebreakdown Modal Pg',
    '/buy/cart/changeproductdetail/modal': 'DS Cart Change Product Detail Modal Pg',
    '/buy/cart-conflict/modal': 'DS Product Details Conflict Modal Pg',
    '/buy/cart/changecolorcapacity/modal': 'DS Cart Change Color Capacity Modal Pg',
    '/buy/cart/newprice/modal': 'DS Cart New Price Modal Pg',
    '/buy/cart/taxes-fees/modal': 'DS Cart Taxes And Fees Modal Pg',
    '/buy/cart/tradeinoffer/modal': 'DS Cart TradeIn Offer Modal Pg',
    '/buy/cart/insurancezipmultiline/modal': 'DS Cart Zipcode Multiline Modal Pg',
    '/buy/checkout/insurancezipmultiline/modal': 'DS CheckOut Zipcode Multiline Modal Pg',
    '/buy/cart/insurancezipmandate/modal': 'DS Cart  Zipcode Mandate Modal Pg',
    '/buy/checkout/insurancezipmandate/modal': 'DS CheckOut Zipcode Mandate Modal Pg',
    '/buy/cart/insurancezipnonmandate/modal': 'DS Cart Zipcode Non Mandate Modal Pg',
    '/buy/cart/internet/acpmissing/modal': 'DS Cart ACP Missing Benefit Modal Pg',
    '/buy/tradeindetail/modal': 'DS Tradein  Make Model Selection Modal Pg',
    '/buy/firstnetverification/modal': 'FirstNet Verification Modal Pg',
    '/buy/firstnetverification/failed/modal': 'FirstNet Failed Verification Modal Pg',
    '/buy/firstnetverification/identry/modal': 'FirstNet ID Entry Modal Pg',
    '/buy/firstnetverification/status/modal': 'FirstNet Verification Status Modal Pg',
    '/dtvnow/promo/modal': 'DS DTVN Promo Information Modal Pg',
    '/buy/dtvnow/promo/modal': 'DS DTVN Promo Information Modal Pg',
    '/buy/tradeindetail/devicetype/modal': 'DS Tradein Make Model Selection Modal Pg',
    '/buy/tradeindetail/devicecondition/modal': 'DS Tradein Device Condition Selection Modal Pg',
    '/buy/orderabandon/modal': 'DS Order Abandon Modal Pg',
    '/buy/returntocart/modal': 'DS Return To Cart Modal Pg',
    '/buy/postpaid/line-selection': 'DS Postpaid Line Selection Pg',
    '/buy/cart/insurance/signup/modal': 'DS Cart Insurance Signup Modal Pg',
};
//# sourceMappingURL=UtilityFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/utils/UtilityFunctions.js
// module id = 89
// module chunks = 8